import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ObjectivePeriodForm from "@/modules/performance/admin/components/objective-period/ObjectivePeriodForm";

export const Route = createFileRoute(
  "/admin/_panel/_performance/performance/objectives/periods/create",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "performance.performance-objective-period.create",
    );

    return {
      crumb: [
        {
          label: context.t("Create Objective-Setting Period", {
            ns: "performance.admin",
          }),
        },
      ],
    } satisfies ChildRouteContext;
  },
});

function RouteComponent() {
  const { t } = useTranslation("performance.admin");
  return (
    <Container
      title={t("Create Objective-Setting Period")}
      description={t(
        "With this section, you can create a objective-setting period for users.",
      )}
      className="flex h-full flex-col"
    >
      <ObjectivePeriodForm />
    </Container>
  );
}
